export interface CheckoutContractsItemDetails {
  brand: string;
  description: string;
  itemId: string;
}
